<template>
    <v-container
        class="flex-column justify-start lg:tw-px-8 lg:tw-pt-12"
        fluid>
        <!-- Título e botões -->
        <v-row
            v-if="building"
            align="start"
            justify="start"
            class="fill-width h-auto justify-start align-content-start tw-mb-4">
            <v-col
                cols="12"
                md="6">
                <h1 class="tw-text-2xl tw-font-bold">{{ building.name }}</h1>
            </v-col>
            <v-col
                class="tw-flex tw-gap-2 md:tw-justify-end md:tw-gap-6"
                cols="12"
                md="6">
                <v-btn
                    :disabled="isLoading || building.id == 0"
                    size="large"
                    width="128"
                    :color="$route.name == 'Building-Dashboard' ? 'primary' : 'gray-200'"
                    :to="{ name: 'Building-Dashboard', params: { id: building.id } }"
                    >{{ $t('views.buildings.dashboard') }}</v-btn
                >
                <v-btn
                    :disabled="isLoading || building.id == 0"
                    size="large"
                    width="128"
                    :color="$route.name == 'Building-Floors' ? 'primary' : 'gray-200'"
                    :to="{ name: 'Building-Floors', params: { id: building.id } }"
                    >{{ $t('views.buildings.blueprint') }}</v-btn
                >
                <v-btn
                    :disabled="isLoading || building.id == 0"
                    density="comfortable"
                    size="large"
                    class="tw-rounded-xl"
                    :color="$route.name == 'Building-Info' ? 'primary' : 'gray-200'"
                    :to="{ name: 'Building-Info', params: { id: building.id } }"
                    icon="mdi-information-variant"></v-btn>
            </v-col>
        </v-row>
        <router-view />
    </v-container>
</template>

<script setup lang="ts">
    import { ref, watch, provide, onBeforeUnmount } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import { ContentType } from '@/contentTypes';
    import { getBuilding } from '@/api/buildings';
    import { useError } from '@/composables/useError';
    import { useAlert } from '@/composables/useAlert';
    import { useSocket } from '@/composables/useSocket';
    import _ from 'lodash';

    const route = useRoute();
    const $router = useRouter();
    const $alert = useAlert();
    const $socket = useSocket();

    const isLoading = ref(false);
    const building = ref<ContentType<'Building'>>();
    const $error = useError();

    watch(
        () => route.params.id,
        () => {
            init();
        },
    );

    async function init(shouldLoad = true) {
        isLoading.value = shouldLoad;
        try {
            const { data } = await getBuilding(route.params.id.toString(), {
                // fields: ['name'],
                populate: {
                    company: {
                        fields: ['name'],
                    },
                    manager: {
                        fields: ['name'],
                    },
                },
                filters: {
                    users: {
                        id: {
                            $in: [36],
                        },
                    },
                },
            });
            building.value = data.data;

        } catch (error: any) {
            if (error.response.status === 404) {
                $router.push({ name: '404', params: { type: 'building' } });
            } else {
                $alert.showAlert({
                    type: 'error',
                    text: $error.getErrorMessage(error, 'views.events.errors'),
                });
            }
        } finally {
            isLoading.value = false;
            $socket.once(`buildings/${route.params.id.toString()}`, (data: any) => {
                init(false);
            });
        }
    }

    provide('building', building);

    init();

    onBeforeUnmount(() => {
        $socket.off(`buildings/${building.value?.id}`);
    });
</script>

<style scoped></style>
